import { compareAsc, format, formatDistance, sub } from "date-fns";

import { dateFormats } from "consts";

export const timestampToDate = (
  date?: string | number | undefined,
  outputFormat: string = dateFormats.main,
  options?: Parameters<typeof format>["2"]
) => {
  return format(date ? new Date(date) : new Date(), outputFormat, {
    ...options,
  });
};

export const timestampToDateTime = (date?: string | number | undefined) => {
  return format(date ? new Date(date) : new Date(), "HH:mm:ss");
};

export const dayDistance = (date: string) =>
  formatDistance(new Date(date), new Date(), {
    addSuffix: true,
  });

export const subDays = (date: string, days: number) => {
  return String(sub(new Date(date), { days }));
};

export const mergeDateWithTime = (date: Date, time: Date) => {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    time.getHours(),
    time.getMinutes(),
    time.getSeconds()
  );
};

export const isOngoing = (startTime: string, endTime: string) => {
  const now = new Date();
  const start = new Date(startTime);
  const end = new Date(endTime);
  return now >= start && now <= end;
};

export const isPast = (time: string) => {
  return new Date(time).getTime() < Date.now();
};

export const pastMinutesFromNow = (startDate: string) => {
  const now = new Date();
  const start = new Date(startDate);
  return Math.floor((now.getTime() - start.getTime()) / 1000 / 60);
};

export const durationTime = (startTime: string, endTime: string) => {
  const start = new Date(startTime);
  const end = new Date(endTime);
  return (end.getTime() - start.getTime()) / 1000 / 60;
};

export const timeToSeconds = (time: string) => {
  if (time.includes(":")) {
    const [hours, minutes] = time.split(":");
    return parseInt(hours) * 3600 + parseInt(minutes) * 60;
  } else {
    return parseInt(time) * 60;
  }
};

export const secondsToTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const addSecondToDate = (date: Date, seconds: number) => {
  return new Date(date.getTime() + seconds * 1000);
};

// date with suffix like "3 days ago"
export const formatDateWithSuffix = (
  date: string,
  settings?: Parameters<typeof formatDistance>["2"]
) => {
  return formatDistance(new Date(), new Date(date), {
    ...settings,
  });
};

export const isDateExceeded = (endTime: string) => {
  const now = new Date();
  const compare = compareAsc(new Date(endTime), now);
  return compare === -1;
};

export const dateToTimestamp = (date: Date) => {
  return format(date, "HH:mm");
};

export const getMidnightTodayDate = () => {
  const offset = new Date().getTimezoneOffset();
  const date = new Date(new Date().setHours(0, -offset, 0, 0));
  return date.toISOString();
};
